import React, { useState, useEffect } from 'react';
import logo from 'assets/img/logo.png';
import offerImage from 'assets/img/offer_image.webp';
import heroImage from 'assets/img/hero.webp';
import certificate1 from 'assets/img/photo_1.webp';
import certificate2 from 'assets/img/photo_2.webp';
import certificate3 from 'assets/img/photo_3.webp';
import certificate4 from 'assets/img/photo_4.webp';
import certificate5 from 'assets/img/photo_5.webp';
import certificate6 from 'assets/img/photo_6.webp';
import certificate7 from 'assets/img/photo_7.jpg';
import certificate8 from 'assets/img/photo_8.jpg';
import 'styles/globals.css';
import 'styles/andrey.css';

const App = () => {
    return (
        <div className="app">
            <AndreyLayout/>
        </div>
    );
}

const AndreyLayout = () => {
    return (
        <div className="layout andrey-app">
            <AndreyHeader />
            <main className="main andrey-page">
                <AndreyOffer />
                <AndreyAbout />
                <AndreyCertificate />
                {/* <AndreyPrices /> */}
                <AndreyFeedbacks />
                <AndreyContacts />
            </main>
            <AndreyFooter />
        </div>
    );
}

const useToggle = (initialValue = false): [boolean, () => void] => {
    const [state, setState] = useState<boolean>(initialValue);
    const toggle = () => setState(prev => !prev);
    return [state, toggle];
};

// Хук для блокировки скролла body при активном меню
const useBodyScrollLock = (isActive: boolean): void => {
    useEffect(() => {
        if (isActive) {
            document.body.classList.add('stop-scrolling');
        } else {
            document.body.classList.remove('stop-scrolling');
        }
        return () => {
            document.body.classList.remove('stop-scrolling');
        };
    }, [isActive]);
};

const AndreyHeader = () => {
    const [isMenuOpen, toggleMenu] = useToggle(false);
    const [isScrolled, setIsScrolled] = useState(false);
    useBodyScrollLock(isMenuOpen);
    useEffect(() => {
        const handleScroll = () => {
        setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll(); // чтобы сразу проверить при загрузке
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (isMenuOpen) toggleMenu();
        }
    };
    return (
        <header className={`andrey-header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="andrey-header-container">
                <div className="andrey-header-content">
                    <div
                        onClick={() => scrollToSection('offer')}
                        className="andrey-logo"
                        role="banner"
                        tabIndex={0}
                        aria-label="Логотип Массажный кабинет Андрей Гречко"
                        onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') scrollToSection('offer');
                        }}
                    >
                        <div className="andrey-logo-icon">
                            <img src={logo} alt="Массаж" />
                        </div>
                        <div className="andrey-logo-text">
                            <h1>Массажный кабинет</h1>
                            <p>Андрей Гречко</p>
                        </div>
                    </div>
                    <nav className="andrey-nav" aria-label="Основная навигация">
                        <button type="button" onClick={() => scrollToSection('offer')}>
                            Главная
                        </button>
                        <button type="button" onClick={() => scrollToSection('about')}>
                            О специалисте
                        </button>
                        <button type="button" onClick={() => scrollToSection('certificate')}>
                            Документы
                        </button>
                        {/* <button type="button" onClick={() => scrollToSection('prices')}>Прайс</button> */}
                        <button type="button" onClick={() => scrollToSection('feedbacks')}>
                            Отзывы
                        </button>
                        <button type="button" onClick={() => scrollToSection('contacts')}>
                            Контакты
                        </button>
                    </nav>
                    <button
                        type="button"
                        onClick={() => scrollToSection('contact')}
                        className="andrey-cta-button"
                    >
                        Записаться
                    </button>
                    <button
                        type="button"
                        onClick={toggleMenu}
                        className="andrey-mobile-menu-btn"
                        aria-expanded={isMenuOpen}
                        aria-controls="andrey-mobile-menu"
                        aria-label={isMenuOpen ? 'Закрыть меню' : 'Открыть меню'}
                    >
                        {isMenuOpen ? (
                        <svg
                            width="24"
                            height="24"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                            focusable="false"
                        >
                            <path d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        ) : (
                        <svg
                            width="24"
                            height="24"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                            focusable="false"
                        >
                            <path d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                        )}
                    </button>
                </div>
                {isMenuOpen && (
                    <div
                        id="andrey-mobile-menu"
                        className="andrey-mobile-menu"
                        role="menu"
                        aria-label="Мобильная навигация"
                    >
                        <nav>
                            <button type="button" onClick={() => scrollToSection('offer')} role="menuitem">
                                Главная
                            </button>
                            <button type="button" onClick={() => scrollToSection('about')} role="menuitem">
                                О специалисте
                            </button>
                            <button type="button" onClick={() => scrollToSection('certificate')} role="menuitem">
                                Документы
                            </button>
                            {/* <button type="button" onClick={() => scrollToSection('prices')} role="menuitem">Прайс</button> */}
                            <button type="button" onClick={() => scrollToSection('feedbacks')} role="menuitem">
                                Отзывы
                            </button>
                            <button type="button" onClick={() => scrollToSection('contacts')} role="menuitem">
                                Контакты
                            </button>
                            <button
                                type="button"
                                onClick={() => scrollToSection('contact')}
                                className="andrey-mobile-cta"
                                role="menuitem"
                            >
                                Записаться
                            </button>
                        </nav>
                    </div>
                )}
            </div>
        </header>
    );
};

const AndreyFooter = () => {
    const currentYear = new Date().getFullYear();
    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (
        <footer className="andrey-footer">
            <div className="andrey-footer-container">
                <div className="andrey-footer-grid">
                    <div className="andrey-footer-brand">
                        <div className="andrey-footer-logo">
                            <div className="andrey-footer-logo-icon">
                                <img 
                                    src={logo}
                                    alt="Массаж"
                                />
                            </div>
                            <div>
                                <h3>Массажный кабинет</h3>
                                <p>Андрей Гречко</p>
                            </div>
                        </div>
                        <p>Профессиональный лечебно-оздоровительный массаж в Кемерово</p>
                    </div>
                    <div className="andrey-footer-section">
                        <h4>Навигация</h4>
                        <ul>
                            <li><button type='button' onClick={() => scrollToSection('offer')}>Главная</button></li>
                            <li><button type='button' onClick={() => scrollToSection('about')}>О специалисте</button></li>
                            <li><button type='button' onClick={() => scrollToSection('certificate')}>Документы</button></li>
                            {/* <li><button type='button' onClick={() => scrollToSection('prices')}>Прайс</button></li> */}
                            <li><button type='button' onClick={() => scrollToSection('feedbacks')}>Отзывы</button></li>
                            <li><button type='button' onClick={() => scrollToSection('contacts')}>Контакты</button></li>
                        </ul>
                    </div>
                    <div className="andrey-footer-section">
                        <h4>Услуги</h4>
                        <ul>
                            <li>Классический массаж</li>
                            <li>Лечебный массаж</li>
                            <li>Спортивный массаж</li>
                            <li>Массаж лица</li>
                            <li>Лимфодренажный</li>
                        </ul>
                    </div>
                    <div className="andrey-footer-section">
                        <h4>Контакты</h4>
                        <div className="andrey-footer-contact-item">
                            <span>{'📞'}</span>
                            <a href="tel:+79130762958">+7 {'('}913{')'} 0762958</a>
                        </div>
                        <div className="andrey-footer-contact-item">
                            <span>{'📍'}</span>
                            <p>Ул. Дзержинского 29а, Кемерово</p>
                        </div>
                        <div className="andrey-footer-contact-item">
                            <span>{'🕐'}</span>
                            <p>По предварительной записи</p>
                        </div>
                    </div>
                    </div>
                    <div className="andrey-footer-bottom">
                    <p>© {currentYear} Андрей Гречко. Все права защищены.</p>
                    <div className="andrey-footer-heart">
                        <span>Создано для вашего</span>
                        <span>здоровья</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}

const AndreyOffer = () => {
    const scrollToAbout = () => {
        const element = document.getElementById('about');
        if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    const scrollToContacts = () => {
        const element = document.getElementById('contacts');
        if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (
        <section id="offer" className="andrey-offer">
            <div className="andrey-offer-bg">
                <img 
                    src={offerImage}
                    alt="Массаж"
                />
            </div>
            <div className="andrey-offer-overlay"></div>
            <div className="andrey-offer-container container">
                <div className="andrey-offer-content">
                    <h1>
                        Оздоровительный массаж в <span className="highlight">Кемерово</span>
                    </h1>
                    <p className="andrey-offer-text">
                        Уделите время своему здоровью. Профессиональный подход с медицинским образованием и опытом работы более 10 лет.
                    </p>
                    <div className="andrey-offer-buttons">
                        <button type='button' onClick={scrollToAbout} className="andrey-btn-primary">
                            Узнать подробнее
                            <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </button>
                        <button type='button' onClick={scrollToContacts} className="andrey-btn-secondary">
                            Записаться на сеанс
                        </button>
                    </div>
                </div>
            </div>
            <div className="andrey-offer-gradient"></div>
        </section>
    );
}

const AndreyAbout = () => {
    const qualifications = [
        {
            icon: '🎓',
            text: 'Медицинское образование и курсы повышения квалификации'
        },
        {
            icon: '💆',
            text: 'Опыт в массаже более 10 лет'
        },
        {
            icon: '🏥',
            text: 'Опыт работы в медицинских центрах'
        }
    ];
    const problems = [
        'Напряжение и боль в мышцах спины и шеи',
        'Нарушение осанки',
        'Головные боли, головокружения',
        'Боли в ногах и руках',
        'Нарушение обмена веществ, отёки',
        'Нарушение сна',
        'Стресс и многое другое'
    ];
    const scrollToCertificate = () => {
        const element = document.getElementById('certificate');
        if (element) element.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <section id="about" className="andrey-about">
            <div className="andrey-about-container container">
                <div className="andrey-about-grid">
                    <div className="andrey-about-image-wrapper">
                        <div className="andrey-about-image">
                            <img
                                src={heroImage}
                                alt="Андрей Гречко"
                            />
                        </div>
                        <div className="andrey-about-badge">
                            <div className="andrey-about-badge-title">10+ лет</div>
                            <p className="andrey-about-badge-text">опыта в массажной терапии</p>
                        </div>
                    </div>
                    <div className="andrey-about-content">
                        <div className="andrey-section-tag">
                            <span>{'👨‍⚕️'} О специалисте</span>
                        </div>
                        <h2>Андрей Гречко</h2>
                        <div className="andrey-qualifications">
                            {qualifications.map((item, index) => (
                                <div key={index} className="andrey-qualification-item">
                                <div className="andrey-qualification-icon">{item.icon}</div>
                                <p className="andrey-qualification-text">{item.text}</p>
                                </div>
                            ))}
                        </div>
                        <p className="andrey-about-text">
                        Ниже вы можете ознакомиться с документами, подтверждающими мою квалификацию.
                        </p>
                        <button type='button' onClick={scrollToCertificate} className="andrey-btn-primary">
                        Перейти к документам
                        </button>
                    </div>
                </div>

                <div className="andrey-about-details">
                    <div className="andrey-about-quote">
                        <p>
                        Современный темп жизни предъявляет высокие требования к физическому и эмоциональному состоянию человека.
                        Малоподвижный образ жизни, связанный с профессиональной и повседневной жизнедеятельностью
                        {'('}офисная работа, вождение автомобиля, чрезмерное использование гаджетов и т.д.{')'},
                        эмоциональные и информационные перегрузки становятся причиной нарушения в работе нашего организма, в числе которых:
                        </p>
                    </div>
                    <div className="andrey-problems-grid">
                        {problems.map((problem, index) => (
                            <div key={index} className="andrey-problem-item">
                                <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                                <span>{problem}</span>
                            </div>
                        ))}
                    </div>
                    <div className="andrey-about-quote">
                        <p>
                        Одним из средств предупреждения и преодоления этих состояний издавна является массаж.
                        </p>
                        <p>
                            <strong>Моя специализация</strong> — классический {'('}лечебно-оздоровительный{')'} массаж с применением дополнительных методик,
                            доказавших свою эффективность и признанных специалистами {'('}постизомтрическая релаксация, 
                            миофасциальный релиз, артикуляция и др.{')'}. В комплексе эти методики дают хороший результат 
                            при описанных выше состояниях.
                        </p>
                        <p>
                        Сеанс массажа строится исходя из индивидуальных особенностей здоровья человека,
                        его жалоб и потребностей. Такой подход обеспечивает более целенаправленное и эффективное воздействие.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

const AndreyCertificate = () => {
    const [selectedImage, setSelectedImage] = useState<number | null>(null);
    const certificates = [
        { id: 1, title: 'Диплом о медицинском образовании', url: certificate1 },
        { id: 2, title: 'Диплом о профессиональной переподготовке', url: certificate2 },
        { id: 3, title: 'Удостоверение о повышении квалификации', url: certificate3 },
        { id: 4, title: 'Документ о прохождении обучения', url: certificate4 },
        { id: 5, title: 'Сертификат массажиста', url: certificate5 },
        { id: 6, title: 'Сертификат массажиста', url: certificate6 },
        { id: 7, title: 'Сертификат массажиста', url: certificate7 },
        { id: 8, title: 'Сертификат массажиста', url: certificate8 }
    ];
    const handlePrevious = () => {
        if (selectedImage !== null) {
        setSelectedImage(selectedImage === 0 ? certificates.length - 1 : selectedImage - 1);
        }
    };
    const handleNext = () => {
        if (selectedImage !== null) {
            setSelectedImage(selectedImage === certificates.length - 1 ? 0 : selectedImage + 1);
        }
    };

    return (
        <section id="certificate" className="andrey-certificate">
            <div className="andrey-certificate-container">
                <div className="andrey-section-header">
                    <div className="andrey-section-tag">
                        <span>{'📜'} Квалификация</span>
                    </div>
                    <h2>Документы об образовании</h2>
                    <p>Дипломы, сертификаты и документы о повышении квалификации</p>
                </div>
                <div className="andrey-certificate-grid">
                    {certificates.map((cert, index) => (
                        <button
                            type='button'
                            key={cert.id}
                            onClick={() => setSelectedImage(index)}
                            className="andrey-certificate-item"
                        >
                            <img src={cert.url} alt={cert.title} />
                            <div className="andrey-certificate-overlay">
                                <p>{cert.title}</p>
                            </div>
                        </button>
                    ))}
                </div>
                {selectedImage !== null && (
                    <div className="andrey-lightbox">
                        <button
                            type='button'
                            onClick={() => setSelectedImage(null)}
                            className="andrey-lightbox-close"
                        >
                            <svg width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>

                        <button
                            type='button'
                            onClick={handlePrevious}
                            className="andrey-lightbox-nav andrey-lightbox-prev"
                        >
                            <svg width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>

                        <button
                            type='button'
                            onClick={handleNext}
                            className="andrey-lightbox-nav andrey-lightbox-next"
                        >
                            <svg width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </button>
                        <div className="andrey-lightbox-content">
                            <img
                                src={certificates[selectedImage].url}
                                alt={certificates[selectedImage].title}
                            />
                            <p className="andrey-lightbox-title">{certificates[selectedImage].title}</p>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}

// export default function AndreyPrices() {
//   const bodyMassage = {
//     types: [
//       'Оздоровительный (по зонам)',
//       'Классический (по зонам и всего тела)',
//       'Лимфодренажный',
//       'Миофасциальный',
//       'Расслабляющий',
//       'Тайский (только 90 мин.)'
//     ],
//     sessions: [
//       { duration: '30 минут', price: '1000 ₽' },
//       { duration: '60 минут', price: '1800 ₽' },
//       { duration: '90 минут', price: '2500 ₽' }
//     ]
//   };

//   const faceMassage = [
//     { name: 'Массаж лица Миофейс', description: 'Комбинированная техника массажа лица, сочетающая в себе приёмы из разных видов массажа (классический, лимфодренажный, испанский, миофасциальный)', price: '1000 ₽' },
//     { name: 'Буккальный массаж лица', description: 'Методика воздействия на глубокие слои мышц лица через ротовую полость. Дает потрясающий омолаживающий эффект', price: '1400 ₽' }
//   ];

//   const packages = [
//     { name: 'Массаж тела 30 мин. + Миофейс', price: '1800 ₽' },
//     { name: 'Массаж тела 30 мин. + Буккальный', price: '2200 ₽' },
//     { name: 'Массаж тела 60 мин. + Миофейс', price: '2600 ₽' },
//     { name: 'Массаж тела 60 мин. + Буккальный', price: '3000 ₽' },
//     { name: 'Массаж тела 90 мин. + Миофейс', price: '3300 ₽' },
//     { name: 'Массаж тела 90 мин. + Буккальный', price: '3700 ₽' }
//   ];

//   const additions = [
//     { name: 'Ультразвуковая терапия/фонофорез 1 зона', price: '500 ₽' },
//     { name: 'Постановка вакуумных банок', price: '500 ₽' }
//   ];

//   const scrollToContacts = () => {
//     const element = document.getElementById('contacts');
//     if (element) element.scrollIntoView({ behavior: 'smooth' });
//   };

//   return (
//     <section id="prices" className="andrey-prices">
//       <div className="andrey-prices-container">
//         <div className="andrey-section-header">
//           <div className="andrey-section-tag">
//             <span>💰 Прайс-лист</span>
//           </div>
//           <h2>Стоимость услуг</h2>
//           <p>Зоны и вид массажа подбираются индивидуально, исходя из Вашего запроса</p>
//         </div>

//         <div className="andrey-prices-grid">
//           <div className="andrey-price-card andrey-price-card-teal">
//             <div className="andrey-price-card-header">
//               <div className="andrey-price-card-header-icon">💆</div>
//               <h3>Массаж тела</h3>
//             </div>

//             <div>
//               <h4>Виды массажа:</h4>
//               <div className="andrey-price-types">
//                 {bodyMassage.types.map((type, index) => (
//                   <div key={index} className="andrey-price-type-item">
//                     <div className="andrey-price-dot"></div>
//                     <span>{type}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div>
//               <h4>Продолжительность сеансов:</h4>
//               <div className="andrey-price-sessions">
//                 {bodyMassage.sessions.map((session, index) => (
//                   <div key={index} className="andrey-price-session">
//                     <div className="andrey-price-session-icon">⏱️</div>
//                     <div className="andrey-price-session-duration">{session.duration}</div>
//                     <div className="andrey-price-session-price">{session.price}</div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           <div className="andrey-price-card andrey-price-card-pink">
//             <div className="andrey-price-card-header">
//               <div className="andrey-price-card-header-icon">✨</div>
//               <h3>Массаж лица</h3>
//             </div>

//             <div className="andrey-face-massage-grid">
//               {faceMassage.map((massage, index) => (
//                 <div key={index} className="andrey-face-massage-item">
//                   <h4>{massage.name}</h4>
//                   <p>{massage.description}</p>
//                   <div className="andrey-face-massage-price">{massage.price}</div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="andrey-price-card andrey-price-card-purple">
//             <div className="andrey-price-card-header">
//               <div className="andrey-price-card-header-icon">🎁</div>
//               <h3>Комплексы</h3>
//             </div>

//             <div className="andrey-packages-grid">
//               {packages.map((pkg, index) => (
//                 <div key={index} className="andrey-package-item">
//                   <div>{pkg.name}</div>
//                   <div className="andrey-package-price">{pkg.price}</div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="andrey-price-card andrey-price-card-amber">
//             <div className="andrey-price-card-header">
//               <div className="andrey-price-card-header-icon">➕</div>
//               <h3>Дополнения к массажу</h3>
//             </div>

//             <div className="andrey-additions-grid">
//               {additions.map((addition, index) => (
//                 <div key={index} className="andrey-addition-item">
//                   <span>{addition.name}</span>
//                   <span className="andrey-addition-price">{addition.price}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         <div className="andrey-price-cta">
//           <p>Остались вопросы? Свяжитесь для получения консультации</p>
//           <button onClick={scrollToContacts} className="andrey-btn-primary">
//             Записаться на сеанс
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

const AndreyFeedbacks = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const feedbacks = [
        // {
        //     id: 1,
        //     name: 'Елена М.',
        //     text: 'Андрей - настоящий профессионал! После его массажа чувствую себя обновленной. Боли в спине прошли уже после третьего сеанса. Очень рекомендую!',
        //     rating: 5,
        //     date: 'Октябрь 2024'
        // },
        {
            id: 1,
            name: 'Елена.',
            text: 'Здравствуйте! Спасибо вам огромное за вашу работу, сегодня целый день летала на работе, словно ничего и не болело! Обязательно буду рекомендовать вас, спасибо, что даёте возможность людям вновь жить без болей в спине!',
            rating: 5,
            date: 'Октябрь 2024'
        },
        {
            id: 2,
            name: 'Виктория.',
            text: 'Андрей, спасибо вам большое. Я чувствую такую лёгкость, кажется, что я даже в росте прибавила, спинка прямая) Ждите меня через полгода. Спасибо)',
            rating: 5,
            date: 'Ноябрь 2024'
        },
        {
            id: 3,
            name: 'Валерий.',
            text: 'Это было не просто расслабление — это настоящее волшебство для тела и души. После массажа я почувствовал, как всё напряжение и усталость просто растворились, а настроение взлетело до небес. Андрей — настоящий мастер своего дела. Уже жду следующей встречи, чтобы снова почувствовать этот заряд энергии и лёгкости.',
            rating: 5,
            date: 'Июнь 2025'
        },
    ];
    const handlePrevious = () => {
        setCurrentSlide(currentSlide === 0 ? feedbacks.length - 1 : currentSlide - 1);
    };
    const handleNext = () => {
        setCurrentSlide(currentSlide === feedbacks.length - 1 ? 0 : currentSlide + 1);
    };
    return (
        <section id="feedbacks" className="andrey-feedbacks">
            <div className="andrey-feedbacks-container">
                <div className="andrey-section-header">
                    <div className="andrey-section-tag">
                        <span>{'💬'} Отзывы</span>
                    </div>
                    <h2>Отзывы клиентов</h2>
                    <p>Что говорят люди о моей работе</p>
                </div>
                <div className="andrey-feedback-slider">
                    <div className="andrey-feedback-card">
                        <div className="andrey-feedback-quote">{'"'}</div>
                        <div className="andrey-feedback-stars">
                            {[...Array(feedbacks[currentSlide].rating)].map((_, i) => (
                                <svg key={i} className="andrey-feedback-star" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                                </svg>
                            ))}
                        </div>
                        <p className="andrey-feedback-text">
                            {feedbacks[currentSlide].text}
                        </p>
                        <div className="andrey-feedback-author">
                            <div className="andrey-feedback-author-info">
                                <div className="andrey-feedback-avatar">
                                    {feedbacks[currentSlide].name.charAt(0)}
                                </div>
                                <div>
                                    <div className="andrey-feedback-name">{feedbacks[currentSlide].name}</div>
                                    <div className="andrey-feedback-date">{feedbacks[currentSlide].date}</div>
                                </div>
                            </div>
                            <div className="andrey-feedback-nav">
                                <button type='button' onClick={handlePrevious} className="andrey-feedback-nav-btn">
                                    <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                    </svg>
                                </button>
                                <span className="andrey-feedback-counter">
                                    {currentSlide + 1} {'/'} {feedbacks.length}
                                </span>
                                <button type='button' onClick={handleNext} className="andrey-feedback-nav-btn">
                                    <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="andrey-feedback-dots">
                        {feedbacks.map((_, index) => (
                        <button
                            type='button'
                            key={index}
                            onClick={() => setCurrentSlide(index)}
                            className={`andrey-feedback-dot ${index === currentSlide ? 'active' : ''}`}
                        />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

const AndreyContacts = () => {
  return (
    <section id="contacts" className="andrey-contacts">
        <div className="andrey-contacts-container">
            <div className="andrey-section-header">
                <div className="andrey-section-tag">
                    <span>{'📞'} Контакты</span>
                </div>
                <h2>Свяжитесь со мной</h2>
                <p>Позвоните или напишите для записи на массаж</p>
            </div>
            <div className="andrey-contacts-grid">
            <div className="andrey-contact-card">
                <div className="andrey-contact-icon">
                <svg width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                </div>
                <h3>Телефон</h3>
                <a href="tel:+79130762958">+7 {'('}913{')'} 0762958</a>
                <small>Доступен для звонков</small>
            </div>
            <div className="andrey-contact-card">
                <div className="andrey-contact-icon">
                    <svg width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                </div>
                <h3>Адрес</h3>
                <p>Ул. Дзержинского 29а,<br/>3 этаж, кабинет 15</p>
                <small>Кемерово</small>
            </div>
            <div className="andrey-contact-card">
                <div className="andrey-contact-icon">
                    <svg width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <h3>Режим работы</h3>
                <p>По предварительной<br/>записи</p>
                <small>Ежедневно</small>
            </div>
            </div>
            <div id='contact' className="andrey-contact-map">
                <div className="andrey-contact-map-card">
                    <div className="andrey-contact-map-grid">
                        {/* <div className="andrey-map-placeholder">
                            <svg width="64" height="64" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            <p>Карта расположения</p>
                            <small>Ул. Дзержинского 29а</small>
                        </div> */}
                        <div className="andrey-contact-cta">
                            <h3>Запишитесь на сеанс</h3>
                            <p>
                            Позвоните или напишите в мессенджер для записи. Я отвечу на все ваши вопросы и подберу оптимальное время для сеанса.
                            </p>
                            <div className="andrey-contact-buttons">
                                {/* Новый "Записаться онлайн" */}
                                <a
                                    href="https://dikidi.ru/1940732" // Замените на реальную ссылку
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="andrey-btn-online-booking"
                                >
                                    <svg
                                    width="20"
                                    height="20"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    style={{ marginRight: '0.5em' }}
                                    >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    Записаться онлайн
                                </a>
                                <a href="tel:+79130762958" className="andrey-btn-call">
                                    <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                    </svg>
                                    Позвонить
                                </a>
                                <a
                                    href="https://wa.me/79130762958"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="andrey-btn-whatsapp"
                                >
                                    <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                                    </svg>
                                    WhatsApp
                                </a>
                                <a
                                    href='https://t.me/+79130762958' // замени username на нужный
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="andrey-btn-telegram"
                                >
                                    <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M21.426 2.174a1.5 1.5 0 00-1.92-.54L2.5 10.5a1.5 1.5 0 00.02 2.7l4.5 1.5 1.5 4.5a1.5 1.5 0 002.7.02l8.866-16.996a1.5 1.5 0 00-.66-1.052zM9.5 15.5l-1-3 7-5-5 8z"/>
                                    </svg>
                                    Telegram
                                </a>
                                {/* Ссылка на ВКонтакте */}
                                <a
                                    href='https://vk.com/a_grechko'  // замени username на нужный
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="andrey-btn-vk"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="icon icon-vk"
                                    >
                                        <path d="M14 19h-4a8 8 0 0 1-8-8v-5h4v5a4 4 0 0 0 4 4h0v-9h4v4.5l.03 0a4.531 4.531 0 0 0 3.97-4.496h4l-.342 1.711a6.858 6.858 0 0 1-3.658 4.789h0a5.34 5.34 0 0 1 3.566 4.111l.434 2.389h0h-4a4.531 4.531 0 0 0-3.97-4.496v4.5z" />
                                    </svg>
                                    VK
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
}

export default App;
